module.exports = __webpack_public_path__ + "site_static/img/mall3.87a5ab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall3.png
// module id = vKnL
// module chunks = 0